import { createAction } from '@reduxjs/toolkit';
import EcomEngineAPI from 'api/ecom_engine_api';
import { trackError } from 'utils/helpers';
import { setBooking } from '../booking';

const deleteReservationStarted = createAction(
  'reservation/deleteReservationStarted'
);
const deleteReservationSucceeded = createAction(
  'reservation/deleteReservationSucceeded'
);
const deleteReservationFailure = createAction(
  'reservation/deleteReservationFailure'
);

const deleteReservation =
  (bookingId, reservationId, updateBooking = true) =>
  (dispatch) => {
    dispatch(deleteReservationStarted());

    return EcomEngineAPI.reservation
      .delete(bookingId, reservationId)
      .then((json) => {
        dispatch(deleteReservationSucceeded());

        if (updateBooking) {
          dispatch(setBooking(json));
        }
      })
      .catch((error) => {
        trackError(error);
        dispatch(deleteReservationFailure(error.message));
        return Promise.reject(error);
      });
  };

const removeAllFerryAndAssociatedVehicles = () => (dispatch) =>
  EcomEngineAPI.booking
    .deleteFerry()
    .then((json) => dispatch(setBooking(json)))
    .catch((error) => {
      trackError(error);

      return Promise.reject(error);
    });

export {
  deleteReservationStarted,
  deleteReservationSucceeded,
  deleteReservationFailure,
  deleteReservation,
  removeAllFerryAndAssociatedVehicles,
};
